var MAX_INT32 = Math.pow(2, 32);

module.exports = function (value) {
  var buf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Buffer.allocUnsafe(8);
  var high = Math.floor(value / MAX_INT32);
  var low = value % MAX_INT32;
  buf.writeUInt32BE(high, 0);
  buf.writeUInt32BE(low, 4);
  return buf;
};